import { useCallback } from 'react';
import { Form } from 'react-final-form';
import { ApolloError } from '@apollo/client';
import { ValidationErrors } from 'final-form';

import { Helmet } from 'react-helmet-async';
import { UpdateDisplayCategoryFormRenderComponent } from './UpdateDisplayCategoryFormRenderComponent';

import { RequiredFieldsType } from '../../../types';
import {
  DisplayCategoryFormProps,
  DisplayCategoryFormRenderProps,
  DisplayCategoryFormValues,
} from '../types';

interface UpdateDisplayCategoryPageProps {
  update: DisplayCategoryFormProps['onSubmit'];
  required?: RequiredFieldsType<Partial<DisplayCategoryFormValues>>;
  validate?: (values: Partial<DisplayCategoryFormValues>) => Promise<ValidationErrors>;
  loading: boolean;
  loaded: boolean;
  error?: ApolloError;
  initialValues: DisplayCategoryFormValues;
}

export const UpdateDisplayCategoryPage = ({
  initialValues,
  validate,
  update,
  loading,
  loaded,
  error,
}: UpdateDisplayCategoryPageProps) => {
  const renderForm: DisplayCategoryFormRenderProps['render'] = useCallback(
    ({ handleSubmit, valid, pristine, submitting }: DisplayCategoryFormRenderProps) => {
      return (
        <UpdateDisplayCategoryFormRenderComponent
          handleSubmit={handleSubmit}
          disabled={!valid || pristine || submitting}
          loading={loading}
          loaded={loaded}
          error={error}
        />
      );
    },
    [loading, loaded, error],
  );

  return (
    <>
      <Helmet>
        <title>Update Display Category</title>
      </Helmet>
      <Form<DisplayCategoryFormValues>
        initialValues={initialValues}
        keepDirtyOnReinitialize
        onSubmit={update}
        render={renderForm}
        validate={validate}
      />
    </>
  );
};
